query LanguageShow($id: ID!) {
  language(id: $id) {
    id
    title
    native
    code
    translation
    createdAt
    updatedAt
    deletedAt
    deleted
  }
}
